import React, { useState } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import OtpTimer from "./OtpTimer";
import { MandatoryField } from "../../common/MandatoryFieldsIcon/MandatoryField";

const AuthWidget2FA = ({ onSubmitOtp, postSubmitLoading, resendOTP }) => {
  const [otp, setOtp] = useState("");
  const [isOtpExpired, setIsOtpExpired] = useState(false);
  const handleOtpExpiry = (val) => {
    setIsOtpExpired(val);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmitOtp(otp);
  };

  const handleOTP = (event) => {
    const { value } = event.target;
    const sanitizedValue = value.replaceAll(/\D/g, "").slice(0, 6);
    setOtp(sanitizedValue);
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="custom-auth-content">
        <div className="custom-fieldset">
          <label htmlFor="otp">
            One-Time Password
            <MandatoryField />
          </label>
          <TextField
            type="text"
            placeholder="Enter One-Time Password"
            disabled={postSubmitLoading}
            id="otp"
            value={otp}
            onChange={(e) => handleOTP(e)}
            variant="outlined"
            maxLength={6}
          />
        </div>
        <div className="custom-fieldset">
          <Button
            disabled={isOtpExpired || otp.length < 6 || postSubmitLoading}
            disableRipple="true"
            className="sign-in"
            id="sign-in-id"
            type="submit"
            variant="contained"
            color="primary"
            data-testid="confirm-otp"
          >
            Submit
          </Button>
        </div>
      </form>
      <div className="custom-fieldset">
        <OtpTimer
          postSubmitLoading={postSubmitLoading}
          resendOTP={resendOTP}
          handleOtpExpiry={handleOtpExpiry}
        />
      </div>
    </div>
  );
};

AuthWidget2FA.propTypes = {
  onSubmitOtp: PropTypes.func.isRequired,
  postSubmitLoading: PropTypes.bool,
  resendOTP: PropTypes.func,
};

export default AuthWidget2FA;
